textarea[data-gab-composer="true"]::placeholder {
  color: var(--gab-composer-placeholder);
  opacity: 1;
}
